import script from "./SelectedFile.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectedFile.vue?vue&type=script&setup=true&lang=js"

import "./SelectedFile.vue?vue&type=style&index=0&id=b079c7c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b079c7c2"]])

export default __exports__